module.exports = __webpack_public_path__ + "829a03fd494ef2b8942d0c6babae8a1a.png";